// Pages
import SalesList from "./pages/SalesList";

import LocationList from "./pages/LocationList";

import SettingsAccount from "./pages/SettingsAccount";
import SettingsSupport from "./pages/SettingsSupport";
import SettingsLegal from "./pages/SettingsLegal";

import SettingsTeam from "./pages/SettingsTeam";
import SettingsTeamCreate from "./pages/SettingsTeamCreate";
import SettingsTeamEdit from "./pages/SettingsTeamEdit";
import SalesListItemDetail from "./pages/SalesListItemDetail";
import SalesPrintResult from "./pages/SalesPrintResult";
import UserConfirm from "~/apps/pos/admin/pages/UserConfirm";
import SalesListItemDelete from "~/apps/pos/admin/pages/SalesListItemDelete";
import SalesListCreate from "~/apps/pos/admin/pages/SalesListCreate";
import { requireRole, requireRoleAndFeature, requireRoleAndPermissionAndFeature } from "~/apps/shared/permissions";
import { Features, Permissions, UserRole } from "~/apps/shared/consts";
import ProductList from "./pages/ProductList";
import ProductGroupList from "./pages/ProductGroupList";
import ProductGroupCreate from "./pages/ProductGroupCreate";
import ProductGroupEdit from "./pages/ProductGroupEdit";
import ProductCategoryList from "./pages/ProductCategoryList";
import ProductCategoryCreate from "./pages/ProductCategoryCreate";
import ProductCategoryEdit from "./pages/ProductCategoryEdit";
import ProductCreate from "./pages/ProductCreate";
import ProductEdit from "./pages/ProductEdit";

// Routes
export const appRoutes = [
  {
    name: "admin",
    path: "/admin",
    forwardTo: "pos.admin.sales",
    canActivate: requireRole(UserRole.AGENT, UserRole.WAREHOUSE_MANAGER),
    children: [
      {
        name: "sales",
        path: "/sales?q&locationId&departmentId&status&startDt&endDt",
        comp: SalesList,
        children: [
          {
            name: "create",
            path: "/create",
            comp: SalesListCreate,
          },
          {
            name: "edit",
            path: "/edit/:saleId",
            comp: SalesListCreate,
          },
          {
            name: "detail",
            path: "/detail/:saleId",
            comp: SalesListItemDetail,
          },
          {
            name: "delete",
            path: "/delete/:saleId",
            comp: SalesListItemDelete,
          },
          {
            name: "printResult",
            path: "/printresult",
            comp: SalesPrintResult,
          },
        ],
      },
      {
        name: "locations",
        path: "/locations?q",
        comp: LocationList,
      },
      {
        name: "products",
        path: "/products",
        forwardTo: "pos.admin.products.all-products",
        canActivate: requireRoleAndPermissionAndFeature(
          [UserRole.AGENT, UserRole.WAREHOUSE_MANAGER],
          Permissions.MANAGE_PRODUCTS,
          Features.ENABLE_PRODUCTS_PAGE,
          "pos.admin.sales"
        ),
        children: [
          {
            name: "all-products",
            path: "/all-products?locationId",
            comp: ProductList,
            children: [
              {
                name: "create",
                path: "/create",
                comp: ProductCreate,
              },
              {
                name: "edit",
                path: "/edit/:productId",
                comp: ProductEdit,
              },
            ],
          },
          {
            name: "groups",
            path: "/groups",
            comp: ProductGroupList,
            canActivate: requireRole(UserRole.AGENT),
            children: [
              {
                name: "create",
                path: "/create",
                comp: ProductGroupCreate,
              },
              {
                name: "edit",
                path: "/edit/:groupId",
                comp: ProductGroupEdit,
              },
            ],
          },
          {
            name: "categories",
            path: "/categories",
            comp: ProductCategoryList,
            canActivate: requireRoleAndFeature(UserRole.AGENT, Features.TRANSACTION_DATA_EXPOSED, "pos.admin.products"),
            children: [
              {
                name: "create",
                path: "/create",
                comp: ProductCategoryCreate,
              },
              {
                name: "edit",
                path: "/edit/:categoryId",
                comp: ProductCategoryEdit,
              },
            ],
          },
        ],
      },
      {
        name: "settings",
        path: "/settings",
        forwardTo: "pos.admin.settings.account",
        comp: SettingsAccount,
        children: [
          {
            name: "account",
            path: "/account",
            comp: SettingsAccount,
          },
          {
            name: "team",
            path: "/team",
            comp: SettingsTeam,
            children: [
              {
                name: "create",
                path: "/create",
                comp: SettingsTeamCreate,
              },
              {
                name: "edit",
                path: "/edit/:userId",
                comp: SettingsTeamEdit,
              },
              {
                name: "confirm",
                path: "/confirm/:userId",
                comp: UserConfirm,
              },
            ],
          },
          {
            name: "support",
            path: "/support",
            comp: SettingsSupport,
          },
          {
            // TODO
            name: "legal",
            path: "/legal",
            comp: SettingsLegal,
          },
        ],
      },
    ],
  },
];

